// extracted by mini-css-extract-plugin
export default {"link":"style_link__G-qeV","centerGrid":"style_centerGrid__4bw2o","img":"style_img__kYGpu","namegame":"style_namegame__IPXDW"};